import classNames from "classnames";
import get from "lodash/get";

import { useStyles } from "./styles";

interface IProps {
  inline?: boolean;
  size?: "big" | "extra-small" | "medium" | "small" | number;
}

export const LoadingSpinner: FC<IProps & TWithTestId> = ({
  className,
  "data-testid": dataTestId,
  inline,
  ref,
  size = "medium",
}) => {
  const classes = useStyles(typeof size === "number" ? { size } : undefined);

  const sizeClassName = get(classes, size) || classes.customSize;

  const result = (
    <div
      className={classNames(classes.loadingSpinner, className, sizeClassName, { inline })}
      data-testid={dataTestId}
      ref={ref}
    >
      <svg className={classes.spinner} height="64px" viewBox="0 0 66 66" width="64px">
        <circle className={classes.path} cx="33" cy="33" r="30" />
      </svg>
    </div>
  );

  if (inline) {
    return (
      <>
        {" "}
        {result}
        {" "}
      </>
    );
  }

  return <div className={classes.fullScreenCenter}>{result}</div>;
};
